import { css, html, PropertyValues } from 'lit';
import { customElement, queryAll } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { RightArrow, LeftArrow } from '../icons/icons';
/** @deprecated */
@customElement('about-popup')
export class AboutPopup extends DeviceAwareComponent {
  static get styles() {
    return [
      commonPopupStyle,
      css`
            :host {
                text-align: center; 
                height:54vh;
                margin: 0px 50px;
                padding: 0 1.25rem;
                font-family: 'Satoshi', sans-serif;
            }
            .fake-wrapper{
              display:flex;
            }
            .carousel {
                width: 63vw;
                height: 43vh;
                position: relative;
              }
              
              .carousel > ul {
                margin: 0;
                padding: 0;
                list-style: none;
              }
              
              .slide {
                position: absolute;
                inset: 0;
                opacity: 0;
                transition: 200ms opacity ease-in-out;
                transition-delay: 200ms;
                display:flex;
              }
              .slide > div{
                background-color: var(--c-bg-normal);
                flex:1;
                text-align: left; 
                border-radius: 1.25rem 0 0 1.25rem;                             
              }
              .about-text{
                font-size: 2rem;
                text-align: left;
                line-height: 3rem;
                margin: 3.75rem;
                display: block;
              }
              div > img {
                background: transparent;
                display: block;
                height:100%;
                width:100%;
                object-fit: cover;
                object-position: center;
                border-radius: 0 1.25rem 1.25rem 0;
              }
              
              .slide[data-active] {
                opacity: 1;
                z-index: 1;
                transition-delay: 0ms;
              }
              
              .carousel-button {
                position: absolute;
                z-index: 2;
                background: none;
                border: none;
                font-size: 4rem;
                top: 50%;
                transform: translateY(-50%);
                color: rgba(18, 18, 19, 1);
                cursor: pointer;
                border-radius: .25rem;
                padding: 0 .5rem;
                background-color: transparent;
                display:flex;
                justify-content:center;
                align-items:center;
                transition: background-color 0.2s linear;
              }
              .carousel-button svg path,
              .carousel-button svg path {
                color: rgb(18, 18, 19);
                fill: rgb(18, 18, 19);
                background-color: transparent;
                transition: all ease 0.3s;
              }
              .carousel-button:hover svg:hover path,
              .carousel-button:focus svg:hover path {
                color: rgba(58, 106, 162, 1);
                fill: rgba(58, 106, 162, 1);
                background-color: transparent;
                transition: all ease 0.3s;
              }
              .carousel-button.prev {
                left: -6rem;
              }
              .carousel-button.next {
                right: -6rem;
              }
              .nav-bar {
                display: inline-block;
                margin: 3.75rem;
              }
              .nav-bar ul {
                display: inline;
                margin-block: 0;
                margin-inline: 0;
                padding: 2rem;
                padding-inline-start: 0;
              }
              .nav-bar ul li {
                float: left;
                margin: 0.5rem;
                list-style: none;
              }
              .nav-bar ul li a {
                display: inline-block;
                background-color: rgba(112, 104, 172, 0.3);
                color: rgba(112, 104, 172, 0.3);
                width: 8px;
                height: 8px;
                font-size: 0;
                text-indent: 100%;
                white-space: nowrap;
                overflow: hidden;
                outline: none;
                box-sizing: border-box;
                transition: .2s ease-in-out;
                border-radius: 50%;
              }
              .nav-bar ul li a:hover {
                background-color: rgba(255, 255, 255, 0.3);
              }
              .nav-bar ul li[data-active] a {
                width: 32px;
                height: 8px;
                border-radius: 4px;
                transform: 0 scaleX(1);
                background-color: rgba(13, 45, 95, 0.85);
              }
              
    `,
    ];
  }


  @queryAll('[data-carousel-button]')
    buttonElements!: HTMLButtonElement[];

  @queryAll('.nav-bar li')
    navElements!: HTMLElement[];

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    this.buttonElements.forEach((ele) => {
      ele.addEventListener('click', () => {
        const offset = ele.dataset.carouselButton === 'next' ? 1 : -1;
        const slides = ele!.closest('[data-carousel]')!.querySelector('[data-slides]') as any;

        const activeSlide = slides!.querySelector('[data-active]');
        const currentIndex = [...slides!.children].indexOf(activeSlide);
        let newIndex = currentIndex + offset;
        if (newIndex < 0) newIndex = slides!.children.length - 1;
        if (newIndex >= slides!.children.length) newIndex = 0;

        this.navElements[newIndex].dataset.active = 'true';
        delete this.navElements[currentIndex].dataset.active;

        slides!.children[newIndex].dataset.active = true;
        delete activeSlide!.dataset.active;
      });
    });
  }


  renderContent() {
    return html`
        <div class="fake-wrapper">
        <section aria-label="Newest Photos">
        <div class="carousel" data-carousel>
          <button class="carousel-button prev" data-carousel-button="prev">${LeftArrow}</button>
          <button class="carousel-button next" data-carousel-button="next">${RightArrow}</button>
          <ul data-slides>
            <li class="slide" data-active>
              <div class="about">
                <span class="about-text">
                <h1>Ahoy!</h1>
               <b>I'm Arie, </b>Ahoy!’s Chief Technology Officer, who loves building marine technology – found his sea-legs in the technology unit of the IDF’s intelligence corps. He can’t choose just one – lake or ocean– but says some days are simply meant for speed-boating on a lake, other days are just destined for sailing the ocean.
          
                </span>
              </div>
              <div>
                <img src="assets/Arie.png" alt="Arie">
              </div>
            </li>
            <li class="slide">
            <div class="about_1">
            <span class="about-text">
            <h1>Ahoy!</h1>
            <b>I'm Tzach, </b>Ahoy!’s VP of Business Development, and our connector-in-chief – counts early morning sunrises on his boat as some of his favorite memories. He is inspired by the book, The Outlaw Ocean by Ian Urbina, and is more of an ocean-guy than a lake-guy.
            Connect with him at <a href="mailto:tzach.segal@ahoy.insure">tzach.segal@ahoy.insure</a>
 
            </span>
            </div>
            <div>
              <img src="assets/Tzach.png" alt="Tzach">
            </div>
           </li>
            <li class="slide">
            <div class="about_2">
            <span class="about-text">
            <h1>Ahoy!</h1>
            <b>I'm Shachar, </b>Ahoy!’s VP of Engineering and our software guru – is a boating instructor and the owner of a boat named Galmor. One of his favorite memories is a holiday spent with friends and family on a luxury catamaran in the area of the Greek island, Lefkada.
            
            </span>
            </div>
            <div>
              <img src="assets/Shachar.png" alt="Shachar">
           </div>
            </li>
            <li class="slide">
            <div class="about_3">
            <span class="about-text">
            <h1>Ahoy!</h1>
            <b>I'm Amit, </b>Ahoy!’s CEO, company creator and captain – has sailed the Atlantic, Pacific, and Indian oceans, and the Mediterranean, Aegean, Black, and Red Seas. He plans to call his next boat, Pelican Pete, after the Ahoy! mascot, which in turn is named after St. Peter, the patron saint of sailors and fishermen. 
            Say ahoy to him here at <a href="mailto:amit@ahoy.insure">amit@ahoy.insure</a>
            
            </span>
            </div>
            <div>
              <img src="assets/Amit.png" alt="Amit">
           </div>
           </li>
           <li class="slide">
           <div class="about_4">
           <span class="about-text">
           <h1>Ahoy!</h1>
           <b>I'm Vivian, </b> Ahoy!’s VP of Strategy & Operations, in charge of operational excellence – is an avid scuba diver and the partial owner of a boat named Angel. One of her fondest memories on the water is of a humpback whale hanging out with her boat in the Outer Barrier Reef. 
           You can find me at <a href="mailto:vivian.serfaty@ahoy.insure">vivian.serfaty@ahoy.insure</a>

           </span>
           </div>
           <div>
             <img src="assets/Vivian.png" alt="Vivian">
          </div>
          </li>

          <li class="slide">
          <div class="about_5">
          <span class="about-text">
          <h1>Ahoy!</h1>
            <b>I'm Kaenan, </b>Ahoy!’s Chief Insurance Officer, who makes sure our insurance is top-notch – has boated on all the major oceans, including the Arctic, and the Antarctic which he sailed into from Argentina through a major storm. That said, he prefers fresh-water lakes to salty sea water. 
          You’ll find him at <a href="mailto:vivian.serfaty@ahoy.insure">kaenan.hertz@ahoy.insure</a>

          </span>
          </div>
          <div>
            <img src="assets/Kaenan.png" alt="Kaenan">
         </div>
         </li>
         
         <li class="slide">
         <div class="about_6">
         <span class="about-text">
         <h1>Ahoy!</h1>
           <strong>I'm Capt. Nitzan</strong>, Ahoy!’s Subject Matter Expert & Marketing Manager, dedicated to ensuring customer happiness and promoting boating safety. 
           Throughout her career as a captain, Nitzan put an emphasis on advancing women in boating. 
           In 2016 she led the first women only flotilla - 20 women on board 3 boats - from Key West to Cuba. 
           In 2019 she captained an 18 boat flotilla organized by the UN to welcome environmentalist Greta Thunberg into the New York Harbor with an all-women crew on her boat. 
           She is inspired by Tracy Edwards MBE, who captained the first all-women crew sailboat at the Whitbread Around the World Race back in 1989-1990 - presented in the 2018 documentary Maiden. 
           Reach out to her with any questions at <a href="mailto:nitzan.levy@ahoy.insure">nitzan.levy@ahoy.insure</a>
         </span>
         </div>
         <div>
           <img src="assets/Nitzan.jpg" alt="Nitzan">
        </div>
        </li>
       </ul>
      </div>
        <div class="nav-bar">
         <ul>
          <li data-active><a class=""></a></li>
          <li><a class=""></a></li>
          <li><a class=""></a></li>
          <li><a class=""></a></li>
          <li><a class=""></a></li>
          <li><a class=""></a></li>
          <li><a class=""></a></li>
         </ul>
        </div>
      </section>
      </div>
    `;
  }
}
